import { z } from "zod";

export const familyMemberHistoryFormSchema = z.object({
  relationshipCode: z.string().min(1, "Relationship is required"),
  conditionCodes: z
    .array(
      z.object({
        code: z.string().min(1, "Condition code is required"),
        display: z.string().min(1, "Condition display is required"),
        system: z.string().min(1, "Condition system is required"),
      }),
    )
    .min(1, "At least one condition is required"),
});
